/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClipIsBulkBillingCompanyResponseData
 */
export interface GetClipIsBulkBillingCompanyResponseData {
    /**
     * 一括請求かどうか
     * @type {boolean}
     * @memberof GetClipIsBulkBillingCompanyResponseData
     */
    isBulkBillingCompany: boolean;
}

export function GetClipIsBulkBillingCompanyResponseDataFromJSON(json: any): GetClipIsBulkBillingCompanyResponseData {
    return GetClipIsBulkBillingCompanyResponseDataFromJSONTyped(json, false);
}

export function GetClipIsBulkBillingCompanyResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClipIsBulkBillingCompanyResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isBulkBillingCompany': json['is_bulk_billing_company'],
    };
}

export function GetClipIsBulkBillingCompanyResponseDataToJSON(value?: GetClipIsBulkBillingCompanyResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_bulk_billing_company': value.isBulkBillingCompany,
    };
}

